export const ProjectData = [

  {
    title: "Social Media Web App",
    description:
      " This web application allows users to create profiles, post updates, interact with other users by commenting and liking their posts, and follow other users. The application also has features such as real-time notifications, search functionality",
    image: "/images/img3.png",
    tags: ["React", " | ", "NodeJS", " | ", "Socket.io", " | ", "MongoDB"],
    github: "https://github.com/kuwarpj/SocialMediaWeb",
    live: "#",

    demo: "./images/live.png",
    source: "./images/git.png",
    id: 2,
  },
  {
    title: "MERN Crud Operation",
    description:
      "I utilized the MERN stack to develop a CRUD operation for a web application. This allowed for efficient data management and a smooth user interface. My proficiency in using ReactJS, NodeJS, and ExpressJS ensured the system's reliability and integrity.",
    image: "./images/img1.jpg",
    tags: ["MONGODB", " | ", "EXPRESSJS", " | ", "REACTJS"],
    github: "https://github.com/kuwarpj/MERN-Crud-Operations",
    live: "#",
    demo: "./images/live.png",
    source: "./images/git.png",

    id: 0,
  },
  {
    title: "BookClub Database ",
    description:
      " The web application includes a reservation system where one user can tag and reserve a book until they return it, making it unavailable to others. The application also includes features such as user authentication, book search, and reservation history.",
    image: "./images/img2.jpg",
    tags: ["HTML", " | ", "CSS", " | ", "Javascript"],
    github:
      "https://github.com/kuwarpj/Bookclub-Database-javascript",
    live: "#",
    demo: "./images/live.png",
    source: "./images/git.png",
    id: 1,
  },
];
